<style scoped>
.app-footer {
  background-color: rgb(var(--v-theme-footer));     
  color: rgb(var(--v-theme-on-footer));            
  padding: 64px 0;
  text-align: center;
}

.footer-logo {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
  border: 4px solid rgb(var(--v-theme-on-surface)); ;
  width:100px;
  margin:auto;
}

.footer-description {
  font-size: 14px;
  line-height: 1.6;
 
  margin-bottom: 16px;
  color:  rgb(var(--v-theme-on-surface));  font-weight: 300!important;
}

.socials v-btn {
  margin-right: 6px;
}

.footer-title {
  font-weight: 600;
  margin-bottom: 12px;
}

.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-list li {
  margin-bottom: 8px;
}

.footer-link {
  font-size: 14px;
  color:  rgb(var(--v-theme-on-surface));
  text-decoration: none;
  font-weight: 300!important;
}

.footer-link:hover {
  text-decoration: underline;
}

.footer-bottom {
  font-size: 13px;
    color:  rgb(var(--v-theme-on-surface));  
  text-align: center;
}




  /* full
.app-footer {
  background-color: rgb(var(--v-theme-footer));     
  color: rgb(var(--v-theme-on-footer));            
  padding: 64px 0;
}

.footer-logo {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
}

.footer-description {
  font-size: 14px;
  line-height: 1.6;
  max-width: 260px;
  margin-bottom: 16px;
  color:  rgb(var(--v-theme-on-surface));  font-weight: 300!important;
}

.socials v-btn {
  margin-right: 6px;
}

.footer-title {
  font-weight: 600;
  margin-bottom: 12px;
}

.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-list li {
  margin-bottom: 8px;
}

.footer-link {
  font-size: 14px;
  color:  rgb(var(--v-theme-on-surface));
  text-decoration: none;
  font-weight: 300!important;
}

.footer-link:hover {
  text-decoration: underline;
}

.footer-bottom {
  font-size: 13px;
    color:  rgb(var(--v-theme-on-surface));  
  text-align: center;
}

 */
</style>



<template>
   <v-footer class="app-footer mt-13" padless >
    <v-container>
      <v-row >
 
    
      <v-col cols="12" md="1"> </v-col>
     
        <!-- Brand / Description -->
        <v-col cols="12" md="10">
          <h3 class="footer-logo mb-6">LWYR</h3>
          <p class="footer-description">
            Curated legal commentary, research, and analysis —
            designed for clarity, speed, and depth.
          </p>

          <div class="socials">
            <v-tooltip text="Coming soon">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="text"
                >
                  <v-icon>mdi-linkedin</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <!--<v-btn icon variant="text"><v-icon>mdi-twitter</v-icon></v-btn>-->
            <v-btn icon variant="text"
              
              href="mailto:operations@lwyr.ca"
              target="_blank"
              rel="noopener"
            ><v-icon>mdi-email</v-icon></v-btn>
          </div>
        </v-col>

        <!-- Columns -->
    


        <v-col cols="12" md="1"> </v-col>
      </v-row>









      <v-divider class="my-6" />

      <div class="footer-bottom">
        © {{ new Date().getFullYear() }} LWYR. All rights reserved.
      </div>
    </v-container>
  </v-footer>








<!-- full -->
   <v-footer class="app-footer mt-13" padless style="display:none">
    <v-container>
      <v-row >
 
    
      <v-col cols="12" md="1"> </v-col>
     
        <!-- Brand / Description -->
        <v-col cols="12" md="2">
          <h3 class="footer-logo">LWYR</h3>
          <p class="footer-description">
            Curated legal commentary, research, and analysis —
            designed for clarity, speed, and depth.
          </p>

          <div class="socials">
            <v-btn icon variant="text"><v-icon>mdi-linkedin</v-icon></v-btn>
            <v-btn icon variant="text"><v-icon>mdi-twitter</v-icon></v-btn>
            <v-btn  
            
            href="mailto:operations@lwyr.ca"
            target="_blank"
            rel="noopener"
            icon 
            variant="text">
              <v-icon>mdi-email</v-icon></v-btn>
          </div>
        </v-col>

        <!-- Columns -->
        <v-col cols="12"  md="2" sm="6"
          v-for="section in sections"
          :key="section.title"
          
        >
          <h4 class="footer-title">{{ section.title }}</h4>
          <ul class="footer-list">
            <li v-for="item in section.items" :key="item">
              <a href="#" class="footer-link">{{ item }}</a>
            </li>
          </ul>
        </v-col>


        <v-col cols="12" md="1"> </v-col>
      </v-row>









      <v-divider class="my-6" />

      <div class="footer-bottom">
        © {{ new Date().getFullYear() }} LWYR. All rights reserved.
      </div>
    </v-container>
  </v-footer>
</template>



<script setup>
const sections = [
  {
    title: 'Practice Areas',
    items: [
      'Corporate',
      'Litigation',
      'IP',
      'Privacy',
      'Employment'
    ]
  },
  {
    title: 'Sources',
    items: [
      'Law Journals',
      'Blogs',
      'News',
      'Cases',
      'Commentary'
    ]
  },
  {
    title: 'Features',
    items: [
      'Daily Briefing',
      'Saved Articles',
      'AI Summaries',
      'Trending'
    ]
  },
  {
    title: 'Company',
    items: [
      'About',
      'Contact',
      'Terms',
      'Privacy'
    ]
  }
]
</script>